import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Box,
  Typography,
  Grid,
  Divider,
} from '@mui/material';
import { Close, PlayCircleOutline, Download } from '@mui/icons-material';
import { computeDurationSeconds, formatDuration, formatFileSize } from '../utils/recordingFormat';

const BRAND = '#1E3A8A';

function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
}

function Field({ label, value }) {
  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="caption" sx={{ color: '#6b7280', display: 'block' }}>{label}</Typography>
      <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word' }}>
        {value === null || value === undefined || value === '' ? '—' : value}
      </Typography>
    </Grid>
  );
}

export default function RecordingDetailsModal({ recording, open, onClose, onWatch, onDownload }) {
  if (!recording) return null;

  const canWatch = recording.recording_status === 'COMPLETED';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '14px' } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 2, bgcolor: BRAND }}>
        <DialogTitle sx={{ p: 0, color: '#fff', fontWeight: 600 }}>Recording Details</DialogTitle>
        <IconButton size="small" onClick={onClose} sx={{ color: '#fff' }} aria-label="Close details">
          <Close fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent sx={{ pt: 3 }}>
        <Grid container spacing={2}>
          <Field label="Candidate Name" value={recording.candidate_name} />
          <Field label="Candidate Email" value={recording.candidate_email} />
          <Field label="Job Title" value={recording.job_title} />
          <Field label="Interview Date" value={formatDate(recording.created_at)} />
          <Field label="Recording Status" value={recording.recording_status} />
          <Field label="Duration" value={formatDuration(computeDurationSeconds(recording))} />
          <Field label="File Size" value={formatFileSize(recording.file_size)} />
          <Field label="File Type / MIME Type" value={recording.mime_type} />
          <Grid item xs={12}><Divider /></Grid>
          <Field label="Recording ID" value={recording.recording_id} />
          <Field label="Interview ID" value={recording.interview_id} />
          <Field label="Started At" value={formatDate(recording.started_at)} />
          <Field label="Ended At" value={formatDate(recording.ended_at)} />
          <Field label="Completed At" value={formatDate(recording.completed_at)} />
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        {canWatch && (
          <Button
            startIcon={<PlayCircleOutline />}
            onClick={() => onWatch(recording)}
            sx={{ textTransform: 'none' }}
          >
            Watch Recording
          </Button>
        )}
        {canWatch && (
          <Button
            startIcon={<Download />}
            onClick={() => onDownload(recording)}
            sx={{ textTransform: 'none' }}
          >
            Download Recording
          </Button>
        )}
        <Button onClick={onClose} variant="contained" sx={{ bgcolor: BRAND, textTransform: 'none' }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
